/**
 * Detail-page chat side effects: register the header chat-click handler,
 * close the chat when the active tab changes, lock body scroll while open.
 *
 * Extracted from StandardDetailPage (file-size split, behaviour unchanged).
 */

import { useEffect, useRef } from "react";

export function useDetailChatEffects({
  showChat,
  setShowChat,
  setOnChatClick,
  activeTab,
}: {
  showChat: boolean;
  setShowChat: (show: boolean) => void;
  setOnChatClick?: (handler: (() => void) | undefined) => void;
  activeTab: string;
}) {
  const previousActiveTabRef = useRef<string | null>(null);

  // Set chat click handler
  useEffect(() => {
    if (setOnChatClick) {
      setOnChatClick(() => () => setShowChat(!showChat));
      return () => {
        if (setOnChatClick) {
          setOnChatClick(undefined);
        }
      };
    }
  }, [setShowChat, setOnChatClick, showChat]);
  
  // Close chat on tab change
  useEffect(() => {
    if (showChat && activeTab && previousActiveTabRef.current !== null && previousActiveTabRef.current !== activeTab) {
      setShowChat(false);
    }
    previousActiveTabRef.current = activeTab;
  }, [activeTab, showChat]);
  
  // Prevent body scroll when chat is open
  useEffect(() => {
    if (showChat) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [showChat]);
}
